import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import TimeDisplayActions from './time-display.action-types';

@Injectable()
export class TimeDisplayEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    requestTerminals$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TimeDisplayActions.requestTimeDisplay),
                tap(() => this.webSocketService.sendMessage(WebSocketMessageType.Time, {}))
            ),
        { dispatch: false }
    );
}
